import 'css-chunksrc/client/scenes/task/datesPickers/styles.scss';export default {
  "dateForm": "_dateForm_13kn6_1",
  "group": "_group_13kn6_7",
  "wrapper": "_wrapper_13kn6_14",
  "icon": "_icon_13kn6_45",
  "title": "_title_13kn6_51",
  "input": "_input_13kn6_58",
  "calendar": "_calendar_13kn6_73",
  "datesWrapper": "_datesWrapper_13kn6_80",
  "completionTitle": "_completionTitle_13kn6_86",
  "completionInput": "_completionInput_13kn6_90"
};